import HostApi from "../../../../settings/HostApi";

const GetCarImagesApiImpl = async (carId: string): Promise<string[]> => {
    const relativeUrl = `/v2/car-images/${carId}/`;
    try {
        const response = await HostApi.get(relativeUrl);
        const images = Array.isArray(response?.images) ? response.images : [];
        return [response?.image_first, ...images].filter(Boolean);
    } catch (error) {
        return [];
    }
};

export default GetCarImagesApiImpl;
